import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { of } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { DigoService } from 'src/app/services/digo.service';

@Component({
    selector: 'app-hm-modal-commissions',
    templateUrl: './hm-modal-commissions.component.html',
    styleUrls: ['./hm-modal-commissions.component.css'],
    standalone: false
})
export class HmModalCommissionsComponent implements OnInit {
    @Input() pdv: any;
    @Input() responseCommissions: any;
    @Output() modalClosed = new EventEmitter<void>();

    isSendingCommissions = false;
    hasSentCommissions = false;
    errorMessage: string | null = null;
    canResend = false; // Si han pasado más de 5 minutos retornará true para permitir reenviar los contratos
    isSignatureRequestActive = false; // Si el usuario ha iniciado la firma de los contratos retornará true
    isCheckingSignature = false;
    documentsSignedSuccess = false;
    docsSignedPendingCheck = false;
    docsSignaturePending = false;

    constructor(
        public activeModal: NgbActiveModal,
        private digoService: DigoService
    ) {}

    ngOnInit() {
        if (this.responseCommissions) {
            this.canResend = this.responseCommissions?.msg?.canResend;
            this.isSignatureRequestActive = this.responseCommissions?.msg?.isSignatureRequestActive;
            this.controlResendButton(this.canResend, this.responseCommissions?.msg?.modal);
        }
    }

    sendCommissionsLink() {

        if (!this.canResend && this.isSignatureRequestActive) {
            this.errorMessage = 'Tienes un contrato pendiente de firma. Revisa tu bandeja de entrada para completarla. Si necesitas reenviar el enlace, espera unos minutos.';
            setTimeout(() => {
                this.errorMessage = null;
            }, 15000);
            return;
        }
        if(this.isSendingCommissions || this.hasSentCommissions || this.docsSignedPendingCheck || this.isCheckingSignature || this.documentsSignedSuccess) {
            // bloquear boton
            return;
        }

        this.isSendingCommissions = true;
        this.errorMessage = null;

        const data = {
            idPdv: this.pdv.info.idpdv,
            contactEmail: this.pdv.info.email
        };

        this.digoService.sendCommisionsContract(data)
        .pipe(
            tap(() => {
                // OLD CODE
                // this.hasSentCommissions = true;
                // this.digoService.isCommissioned = false; // Liberar el bloqueo --> Lo he pasado al bloque cuando se comprueba que los documentos ya se han firmado
                // setTimeout(() => {
                //   this.closeModal();
                // }, 1200);
                if (data) {
                    this.isSendingCommissions = false;  // Descomentar para simular proceso
                    this.hasSentCommissions = true;  // Descomentar para simular proceso
                    setTimeout(() => {
                        this.checkDocumentsSignature(true, true);
                    }, 2000);

                    // Si el estado de la firma todavía está pendiente, llamar a los 5 minutos y 30 segungos al endpoint para comprobar si
                    // se puede volver a habilitar el botón de reenviar enlace.
                    setTimeout(() => {
                        if (this.isSignatureRequestActive && !this.canResend) {
                            this.checkDocumentsSignature(false, true);
                        }
                    }, 5 * 60 * 1000 + 30 * 1000); // en caso de que el usuario se mantenga en la misma pantalla después de haberle dado al botón enviar
                    // a los 5 minutos 30 segundos, si el proceso ya se ha iniciado y el botón todavía está deshabilitado,
                    // lanzamos una petición al back para comprobar si se puede volver a habilitar el botón de reenviar enlace.
                }
            }),
            catchError(error => {
                // console.log('error -->', error);
                // Verificamos el código 400 y el contenido del mensaje
                if (error.status === 400 && error.error === 'Contract signed') {
                    this.errorMessage = 'La documentación ya está firmada. Haz click en el botón "Comprobar estado de la firma" para continuar.';
                    this.docsSignedPendingCheck = true;
                } else if (error.status === 400 && Array.isArray(error.error) && error.error[0] === 'Contract signed') {
                    this.errorMessage = 'La documentación ya está firmada. Haz click en el botón "Comprobar estado de la firma" para continuar.';
                    this.docsSignedPendingCheck = true;
                } else {
                    this.errorMessage = 'Hubo un problema al enviar la solicitud. Inténtelo de nuevo.';
                }
                return of(null);
            }),
            finalize(() => this.isSendingCommissions = false)
        )
        .subscribe();
    }

    closeModal() {
        this.activeModal.dismiss();
        this.modalClosed.emit(); // Notifica al padre que el modal se cerró
    }

    checkDocumentsSignature(startChecking = false, suppressAutoClose = false) {
        if (!startChecking) this.isCheckingSignature = true;
        // Comprobamos el estado de las firmas de los contratos de comisionado
        this.digoService.checkPdvCommisionsContract(this.pdv?.info?.idpdv)
        .pipe(
            tap((result: any) => {
                if (result?.msg) {
                    this.canResend = result?.msg?.canResend;
                    if (this.canResend) this.hasSentCommissions = false;
                    if (result?.msg?.isSignatureRequestActive) this.isSignatureRequestActive = result.msg.isSignatureRequestActive;
                    if (result?.msg?.modal == 'hidden' && !result?.msg?.isSignatureRequestActive && !suppressAutoClose) {
                        this.documentsSignedSuccess = true;
                        setTimeout(() => {
                            this.digoService.resolveCommissionsBlock();
                            this.isSignatureRequestActive = result?.msg?.isSignatureRequestActive;
                            this.closeModal();
                        }, 2000);
                    } else {
                        if (!startChecking) {
                            this.docsSignaturePending = true;
                                setTimeout(() => {
                                    this.docsSignaturePending = false;
                                }, 20000);
                        }
                    }
                    this.controlResendButton(this.canResend, result?.msg?.modal);
                }
            }),
            catchError(error => {
                console.error('Error:', error);
                return of(false);
            }),
            finalize(() => this.isCheckingSignature = false)
        ).subscribe()
    }

    controlResendButton(canResend, modal) {
        if (!canResend && modal == 'display') {
            setTimeout(() => {
                this.checkDocumentsSignature(true, true);
            }, 25000);
        }
    }
}
